import type { Product } from '@bucketplace/common';
import { type QueryFunctionContext, skipToken } from '@tanstack/react-query';
import type { KyHeadersInit } from 'ky/distribution/types/options';
import { z } from 'zod';

export const getStoreItemsInputSchema = z.object({
  ids: z.array(z.union([z.number(), z.string()])),
  isLoggedIn: z.boolean(),
  showCouponBadge: z.boolean(),
});

export const getStoreItemsResponseSchema = z.object({
  items: z.array(z.custom<Product>()),
});

export type GetStoreItemsInput = z.infer<typeof getStoreItemsInputSchema>;
export type GetStoreItemsResponse = z.infer<typeof getStoreItemsResponseSchema>;
export type GetStoreItemsApi = (params: {
  input: GetStoreItemsInput;
  headers?: KyHeadersInit;
  signal?: AbortSignal;
}) => Promise<GetStoreItemsResponse>;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createGetStoreItemsQueryOptions = ({
  api,
  input,
  skip,
}: {
  api: GetStoreItemsApi;
  input: GetStoreItemsInput;
  skip?: boolean;
}) => {
  return {
    queryKey: ['getStoreItems', input],
    queryFn: skip
      ? skipToken
      : ({ signal }: QueryFunctionContext) => api({ input, signal }),
  } as const;
};
